import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import CreateDomainModal from 'components/CreateDomainModal/CreateDomainModal';

class EmptyDomainCard extends Component {
  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="domain-empty">
        <div className="domain-empty__title">Create your first domain</div>
        <CreateDomainModal handleSubmit={handleSubmit} />
      </div>
    );
  }
}

export default EmptyDomainCard;



// WEBPACK FOOTER //
// ./src/components/DomainCard/EmptyDomainCard.js